import {match} from 'ts-pattern'
import {NotifyCommentCommon} from './notifyTypes'
import {nav} from 'components/portal/nav'

export namespace NotifyComment {
  export const link = (
    type: LinkType,
    {question, subquestion, comment, workspace_id}: NotifyCommentCommon & {workspace_id: string},
    options: {external: boolean}
  ) =>
    match(type)
      .with('subq', () =>
        nav.question.getUrl(
          {
            question_id: question.id,
            subquestion_id: subquestion?.id,
            comment_id: comment.id,
            workspace: workspace_id
          },
          options
        )
      )
      .with('question', () => nav.question.getUrl({question_id: question.id, workspace: workspace_id}, options))
      // link to the comment within the question (not subquestion) because that's generally what people use/prefer
      .with('comment', () =>
        nav.question.getUrl({question_id: question.id, comment_id: comment.id, workspace: workspace_id}, options)
      )
      .exhaustive().url
  export type LinkType = 'comment' | 'subq' | 'question'
}
